import React, { useState, useEffect } from 'react';
import '../../App.css';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { ArrowForwardIos, Addchart } from '@mui/icons-material';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authActions } from '../../store/auth-slice';

const initialFValues = {
  id: 0,
  filePath: '',
};

function EmployeeForm() {
  const [values, setValues] = useState(initialFValues);
  const [fileData, setFileData] = useState();
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Get the dispatch function

  // **Helper function to fetch and dispatch the logo**
  const getCompanyLogoURL = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/company-master/get-logo`, { credentials: 'include' });
      if (!response.ok) {
        throw new Error('Failed to fetch company logo.');
      }
      const imageBlob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        // Only update logo, preserve username and login state
        dispatch(authActions.setActiveCompanyLogoURL(base64data));
        localStorage.setItem('companyLogoBase64', base64data);
        localStorage.setItem('companyLogoURL', base64data);
      };
      reader.readAsDataURL(imageBlob);
    } catch (error) {
      console.error("Error fetching company logo:", error);
      // Don't clear existing logo on error, just log it
    }
  };

  // **useEffect to load the logo on initial component mount**
  useEffect(() => {
    const storedLogo = localStorage.getItem('companyLogoBase64');
    const storedUserName = localStorage.getItem('activeUserName');
    
    // Ensure username is preserved
    if (storedUserName) {
      dispatch(authActions.setActiveUserName(storedUserName));
    }
    
    if (storedLogo) {
      dispatch(authActions.setActiveCompanyLogoURL(storedLogo));
    } else {
      getCompanyLogoURL();
    }
  }, [dispatch]);

  const validate = () => {
    let temp = {};
    temp.filePath = values.filePath ? '' : 'This field is required.';
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === '');
  };

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  };

  function handleFileChange(e) {
    setFileData(e.target.files[0]);
    // You might want to update the `values` state here for validation
    setValues({ ...values, filePath: e.target.files[0] ? e.target.files[0].name : '' });
  }

  // No need for handleInputChange if you're not using it.
  // function handleInputChange(e) {
  //   const { name, value } = e.target;
  //   setValues({
  //     ...values,
  //     [name]: value,
  //   });
  // }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) { // Call validate() before submitting
        const data = new FormData();
        data.append('image', fileData);
        fetch(`${process.env.REACT_APP_API_BASE_URL}/company-master/insert-logo`, {
            credentials: 'include',
            method: 'POST',
            body: data,
        })
        .then((response) => {
            if (response.status === 200) {
                setNotify({
                    isOpen: true,
                    message: 'Logo uploaded successfully!',
                    type: 'success',
                });
                // Ensure username is preserved before refreshing logo
                const storedUserName = localStorage.getItem('activeUserName');
                if (storedUserName) {
                    dispatch(authActions.setActiveUserName(storedUserName));
                }
                // Call the helper function here to refresh the logo
                getCompanyLogoURL();
            } else if (response.status === 401) {
                setNotify({
                    isOpen: true,
                    message: 'Session Expired!',
                    type: 'error',
                });
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } else {
                setNotify({
                    isOpen: true,
                    message: 'Upload failed!',
                    type: 'error',
                });
            }
        })
        .catch((error) => {
            console.error(error);
            setNotify({
                isOpen: true,
                message: 'An error occurred!',
                type: 'error',
            });
        });
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '50px', fontWeight: '500px' }}>
      <Paper variant="outlined" elevation={5}>
        <Grid className="form-title" style={{ marginBottom: '-10px', marginLeft: '-30px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              Insert Company Logo
            </Typography>
          </Grid>
          <Grid item>
            <Addchart style={{ marginLeft: '-50px' }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '30px' }}>
            <div className="mb-3">
              <label htmlFor="formFile" className="form-label">
                Select a file:
              </label>
              <input
                name="filePath"
                className="form-control"
                type="file"
                id="formFile"
                onChange={handleFileChange}
              />
              {/* Optional: Display validation error */}
              {errors.filePath && <span style={{ color: 'red' }}>{errors.filePath}</span>}
            </div>

            <Stack display="flex" sx={{ alignItems: 'flex-end' }}>
              <Button variant="contained" endIcon={<ArrowForwardIos />} type="submit">
                Save
              </Button>
            </Stack>
          </Stack>
        </form>
        <Notification notify={notify} setNotify={setNotify} />
      </Paper>
    </Box>
  );
}

export default EmployeeForm;